import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {AplicacionTipoService} from 'src/app/_module/procesadora/aplicacion-datos/aplicacion-tipo/aplicacion-tipo.service';
import {AplicacionService} from 'src/app/_module/procesadora/aplicacion-datos/aplicacion/aplicacion.service';
import {NotificacionesService} from 'src/app/_app_services/notificaciones.service';
import {Formularios} from 'src/app/_helpers/clases/formularios';
import {PageHeaderDataService} from 'src/app/shared/services/page-header-data.service';
import {PageHeaderData} from 'src/app/shared/components/forms-header/page-header-data';
import {Aplicacion} from 'src/app/_models/aplicacion';
import {Entidad} from '../../../../../_models/entidad';
import {AplicacionTipo} from '../../../../../_models/aplicacion-tipo';
import {EntidadService} from '../../../entidad-datos/entidad/entidad.service';


/**
 * Formulario ABM de las aplicaciones utilizadas por el usuario.
 * @author Alejandro Planas
 */
@Component({
  selector: 'app-aplicacion-form',
  templateUrl: './aplicacion-form.component.html',
  //   styleUrls: ['./aplicacion-form.component.scss']
})
export class AplicacionFormComponent extends Formularios<Aplicacion> implements OnInit {

  constructor(
    public router: Router,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public notificacionService: NotificacionesService,
    public service: AplicacionService,
    private headerDataService: PageHeaderDataService,
    public aplicacionTipoService: AplicacionTipoService,
    public entidadService: EntidadService
  ) {
    super(router, dialog, 'procesadora/aplicacion', service, notificacionService);

  }

  ngOnInit(): void {
    super.ngOnInit();
    super.formularioAbs = this.construirFormGroup();
    if (super.editar) {
      super.formularioAbs.setValue(this.service.getItem());
    } else {
      this.service.restartItem();
    }
    this.headerDataService.setHeaderData(new PageHeaderData('Aplicacion', this.rutaPadre, true));
  }

  construirFormGroup(): FormGroup {
    return this.fb.group({
      id: [null],
      nombre: [{value: '', disabled: super.dis}, Validators.required],
      app_id: [{value: '', disabled: super.dis}],
      verificacion_automatica: [{value: true, disabled: super.dis}],
      entidad: [new Entidad()],
      aplicacion_tipo: [new AplicacionTipo()],
    });
  }

  getErrorMessage(cName: string): string {
    // if (this.formularioAbs.controls[cName].hasError('required')) {
      return 'Campo requerido';
    // }
  }


}
